module.exports = __webpack_public_path__ + "static/img/join_8.83a9dd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_8.jpg
// module id = HdM0
// module chunks = 1